import React from 'react';
import { Container } from './styled'

const Checkbox= ({
  isChecked,
  checkHander,
  openHandler,
  isOpen,
  message
}) => {
  return (
    <Container isCheck={isOpen}>
      <label className="checkbox-label">
        <input type="checkbox" checked={isChecked} onChange={checkHander} />
        <span /><p>{message}</p>  
      </label>
      <button onClick={openHandler} className='svg-wrapper'>
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_771_1500)">
            <path d="M5.98975 12.0104L15.6466 21.6673L25.657 11.6569" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          </g>
          <defs>
            <clipPath id="clip0_771_1500">
              <rect width="32" height="32" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      </button>
   </Container>
  );
};

export default Checkbox;
